<template>
  <u-animate-container>
    <div>
      <front-header />
      <div class="container-section">
        <div class="max-container">
          <v-row>
            <v-col>
              <u-animate name="fadeInLeft" class="wow" delay="0.6s">
                <div class="login-left-content">
                  <h1>
                    Welcome to
                    <strong>Grow Pharma</strong>
                  </h1>
                  <p>Type in your info and let’s get started!</p>
                  <div class="image-box">
                    <img
                      src="https://growbiotech-prod.s3.eu-west-2.amazonaws.com/1606300052247.png"
                      alt
                    />
                  </div>
                </div>
              </u-animate>
            </v-col>
            <v-col>
              <u-animate name="fadeInRight" class="wow" delay="0.6s">
                <div class="login-right-block">
                  <div class="login-box" v-show="step === 1">
                    <h5
                      class="text-center display-1 font-weight-black modal-title"
                    >
                      <strong>Recover incomplete Sign Up</strong>
                    </h5>
                    <p class="mt-10 mb-10 text-center title-content">
                      Don’t worry, Enter your e-mail and we’ll redirect to where
                      you left off.
                    </p>
                    <ValidationObserver
                      class="vuetify-form"
                      ref="obs"
                      v-slot="{ invalid, validated, passes }"
                    >
                      <v-form class="mt-10">
                        <v-row>
                          <v-col cols="12">
                            <VTextInput
                              v-model="email"
                              rules="required|email"
                              placeholder="Your Email Address"
                              label="Email Address *"
                            />
                          </v-col>
                          <v-col cols="12" class="text-center mt-5">
                            <v-btn
                              :disabled="invalid || !validated"
                              x-large
                              min-width="275"
                              min-height="50"
                              color="#FCAE00"
                              :dark="!invalid"
                              @click="passes(next)"
                              >Continue</v-btn
                            >
                          </v-col>
                        </v-row>
                      </v-form>
                    </ValidationObserver>
                  </div>
                </div>
              </u-animate>
            </v-col>
          </v-row>
        </div>
      </div>
      <front-footer />
    </div>
  </u-animate-container>
</template>

<script>
import { UAnimateContainer, UAnimate } from "vue-wow";
import FrontHeader from "../components/layouts/FrontHeader";
import FrontFooter from "../components/layouts/FrontFooter";
import { AuthService } from "@/services";
import { ValidationObserver } from "vee-validate";
import { VTextInput } from "@/components/inputs";

export default {
  name: "Login",
  components: {
    UAnimateContainer,
    UAnimate,
    FrontHeader,
    FrontFooter,
    ValidationObserver,
    VTextInput
  },
  data() {
    return {
      valid: false,
      step: 1,
      email: "",
      emailRules: [
        v => !!v || "E-mail is required!",
        v => /.+@.+\..+/.test(v) || "E-mail must be valid"
      ]
    };
  },
  methods: {
    async next() {
      const response = await AuthService.getCurrentRegisterStep({
        email: this.email
      });
      if (response) {
        this.$store.dispatch("user/setUser", response.data.user);
        this.$router.push("/signup");
      }
    }
  }
};
</script>
